import React from "react";

const SkeletonCard = () => {
    return (
        <div style={styles.skeletonCard}>
            <div style={styles.skeletonTitle}></div>
            <div style={styles.skeletonText}></div>
            <div style={styles.skeletonButton}></div>
        </div>
    );
};

const styles = {
    skeletonCard: {
        backgroundColor: "#f3f3f3",
        width: "320px",
        height: "200px",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        padding: "20px",
        boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.08)",
        animation: "pulse 1.5s infinite ease-in-out",
    },
    skeletonTitle: {
        width: "60%",
        height: "20px",
        backgroundColor: "#e0e0e0",
        borderRadius: "4px",
    },
    skeletonText: {
        width: "80%",
        height: "15px",
        backgroundColor: "#e0e0e0",
        borderRadius: "4px",
    },
    skeletonButton: {
        width: "50%",
        height: "25px",
        backgroundColor: "#d6d6d6",
        borderRadius: "6px",
    },
};

export default SkeletonCard;
